module.exports = __webpack_public_path__ + "img/moshi.1314d89e.jpg";